import React from 'react';

export default class Page5 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToFocusOnTheBiggerPicture');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Broader understanding</div>
                                            <p>This tool will help you gain a much broader understanding of
                                                the bigger picture beyond your
                                                original beliefs and the result will be a more complete
                                                picture.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>You should have more of an idea of how to start thinking on a
                                                broader level. Here are some
                                                suggestions about what to do next, although this list is by
                                                no means exhaustive:</p>
                                            <div className="border_subtitle">Gather feedback on existing
                                                performance
                                            </div>
                                            <p>You may find it useful to ask for formal or informal
                                                feedback. This may help you to understand
                                                how other people perceive you and get advice about where you
                                                can make modifications or
                                                improvements to think about the wider context. You can also
                                                use this information to manage
                                                people’s future expectations about your approach as well as
                                                to monitor your progress.</p>
                                            <div className="border_subtitle">Consider a role model</div>
                                            <p>Try and identify someone you know who you admire for their
                                                ability to think about the broader
                                                context. Think about what it is you like about their
                                                approach. This is the starting point for you to
                                                develop a plan to improve – see below.</p>
                                            <div className="border_subtitle">Look for opportunities to
                                                practise
                                            </div>
                                            <p>Watch out for opportunities in your current work or elsewhere
                                                to practise using the TOWS grid or
                                                another approach that will help you to see the bigger
                                                picture.</p>
                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>Use this tool to write out a personal, focused development
                                                plan on how you can best think more
                                                broadly.</p>
                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">
Further Information
</span></div>

                                            <p>If you found this tool useful then you are likely to find the
                                                following tools both insightful and relevant: </p>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToIdentifyYourPersonalMeaning')}>How
                                                        to identify your personal meaning</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToDevelopStrategicLongTermGoals')}>How
                                                        to develop strategic long-term goals </div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToMakeComplexIdeasSimpleClearAndConcise')}>How
                                                        to make complex ideas simple, clear and concise</div>
                                                    </li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToMakeEthicalDecisions')}>How
                                                        to make ethical decisions</div></li>
                                                    <li><div className="link_color button-link-redirect thought"
                                                           onClick={this._savePageStatus('HowToTakeResponsibility')}>How
                                                        to take responsibility.</div></li>

                                                </ul>
                                            </div>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Schyns,
                                                    P. &amp; Oliva, A. (1999). Dr. Angry and Mr. Smile: when
                                                    categorization flexibly modifies the perception
                                                    of faces in rapid visual presentations. <span
                                                        className="subtiltereg">Cognition</span>, 69,
                                                    243-265.</p></li>
                                                <li><p className="further_info_content"> Ginter, P., Swayne,
                                                    L. &amp; Duncan, W. (2002). <span
                                                        className="subtiltereg">Strategic Management of Healthcare Organizations.</span>
                                                    Blackwell Publishing.</p></li>
                                            </ol>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought"> &lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Thought')}
                                                    className="button-next-previous-done thought">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}